__turbopack_context__.v({
  "container": "TkRl9G_container",
  "content": "TkRl9G_content",
  "logo": "TkRl9G_logo",
  "nerd_info": "TkRl9G_nerd_info",
  "nerd_info_github": "TkRl9G_nerd_info_github",
  "powered_by_item": "TkRl9G_powered_by_item",
  "powered_by_list": "TkRl9G_powered_by_list",
});
